export const downloadFile = (fileName: string) => {
  const a = document.createElement('a');

  a.style.display = 'none';
  a.href = fileName;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};

export default downloadFile;
